

import { createUseStyles } from 'react-jss';
import colors from "../../utils/colors";

var styles = {
  // Keyframes:
  '@keyframes slideDown': {
    from: { top: '-5.6rem', zIndex: '-1', visibility: 'hidden' },
    to: { top: '6.5rem', zIndex: '9', visibility: 'visible' }
  },

  '@keyframes slideUp': {
    from: { top: '6.5rem', zIndex: '9', visibility: 'visible' },
    to: { top: '-5.6rem', zIndex: '-1', visibility: 'hidden' }
  },

  // Styles:
  toast: function toast(props) {return {
      width: '100%',
      position: 'fixed',
      color: props.textColor || colors.neutral.white,
      padding: '1.6rem 2rem 1.6rem 1.6rem',
      top: '6.5rem',
      left: '0',
      zIndex: '9',
      boxSizing: 'border-box'
    };},
  toastText: {
    margin: '0 auto',
    maxWidth: '80vh',
    textAlign: 'center',
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 700
    },
    letterSpacing: '0.03rem'
  },
  toastCloseIcon: {
    width: '2.4rem',
    height: '2.4rem',
    position: 'absolute',
    top: '50%',
    right: '1.2rem',
    transform: 'translate(0, -50%)',
    boxSizing: 'border-box',
    cursor: 'pointer',
    '&:focus': {
      outline: 'white solid 0.15rem',
      outlineOffset: '0.3rem'
    }
  },
  success: {
    backgroundColor: colors.green[500]
  },
  warning: {
    backgroundColor: colors.red[500]
  },
  custom: function custom(props) {return {
      backgroundColor: props.backgroundColor || colors.neutral[400]
    };},
  showToast: {
    animationName: '$slideDown',
    animationDuration: '1.5s'
  },
  hideToast: {
    animationName: '$slideUp',
    animationDuration: '1.5s'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map